import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import firebase from 'firebase';
import store from '../../store';

const database = firebase.database();


const styles = { marginTop: '40px' }

class ViajesConductor extends Component {

	constructor(props) {

		super(props);
		this.state = {
			empleados: [],
			clientes: [],
			socios: [],
			labels: ['Empleado', 'Fecha', 'Costo', 'Lugar', 'Socio'],
			viajes: [],
			viajestemp: [],
			fecha_actual: '',
			fecha_minima: '',
			fecha_maxima: '',
			input_disabled: 'disabled',
			viajestemp:[],
			salvar:[],
			salvarFiltrado:[]

		}

		this.sociosRef = database.ref().child('Socios');
		this.empleadosRef = database.ref().child('Empleados');
		this.viajeRef = database.ref().child('Viaje');
		this.handleClickPrint = this.handleClickPrint.bind(this);
		this.updateStateReport = this.updateStateReport.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);

		this.handleInputDate1Changed = this.handleInputDate1Changed.bind(this);
		this.handleInputDate2Changed = this.handleInputDate2Changed.bind(this);

		this.handleOnClickRegistrosGenerales = this.handleOnClickRegistrosGenerales.bind(this);

		//1)Obtener la fecha actual y establecerla como fecha maxima de los input
		//2)Establecer en disabled el segundo input  de manera predefinida hasta que se seleccione una fecha en el input de inicio
		//3)Establecer como fecha minima del segundo input la fecha escogida en el primero
		//4)Cuando se establesca un valor en el segundo input hacer el filtro para cambiar el array de viajes del state
		//5)Filtrar todos los registros que esten entre las fechas especificadas
		//6)Poner boton de limpiar para volver al estado 1) donde los input no tiene valor definido


		//Obteniendo la fecha actual para validar calendarios de fechas

		let f = new Date();

		this.state.fecha_actual = f.getFullYear() + '-' + ((f.getMonth() + 1) > 10 ? f.getMonth : '0' + (f.getMonth() + 1)) + '-' + (f.getDate() > 10 ? f.getDate() : '0' + f.getDate());

	}


	componentDidMount() {

		this.sociosRef.on('value', this.gotDataSocios, this.errDataSocios);

	}

	componentWillMount() {


		this.sociosRef.on('value', this.gotDataSocios, this.errDataSocios);


	}

	updateStateReport() {


		store.dispatch({

			type: "STATE_REPORT",
			labels_report: this.state.labels,
			data_report: this.state.viajes,
			tipo_reporte: 'viajes_conductor'

		})

	}




	gotDataEmpleados = (data) => {

		let newEmpleados = [];

		if (data.val() !== null && this.state.socios.length !== 0) {

			let dataempleados = data.val();

			let keys = Object.keys(dataempleados);


			for (let i = 0; i < keys.length; i++) {

				let k = keys[i];

				let nombre_socio = '';

				let socio = this.state.socios.find(socios => socios.key === dataempleados[k].socio);

				try {

					nombre_socio = socio.nombre + ' ' + socio.apellido;

				}
				catch (err) {

				}

				newEmpleados.push({
					key: k,
					nombre: dataempleados[k].nombre,
					socio: nombre_socio
				})

			}
			this.setState({ empleados: newEmpleados });
			this.viajeRef.on('value', this.gotDataViajes, this.errDataViajes);
		}

	}
	errDataEmpleados = (err) => {

		console.log(err);
	}

	gotDataSocios = (data) => {

		let newSocios = [];



		if (data.val() !== null) {

			let datasocios = data.val();

			let keys = Object.keys(datasocios);

			for (let i = 0; i < keys.length; i++) {

				let k = keys[i];


				newSocios.push({

					key: k,
					nombre: datasocios[k].Nombre,
					apellido: datasocios[k].Apellido

				})

			}
			this.state.socios = newSocios;
			this.setState({ socios: this.state.socios })
			this.empleadosRef.on('value', this.gotDataEmpleados, this.errDataEmpleados);
		}

	}

	errDataSocios = (err) => {

		console.log(err);

	}

	gotDataViajes = (data) => {


		let newViajes = [];


		if (data.val() !== null && this.state.empleados.length !== 0 && this.state.socios.length !== 0) {


			let dataviajes = data.val();

			let keys = Object.keys(dataviajes);

			for (let i = 0; i < keys.length; i++) {

				let k = keys[i];


				let empleado = this.state.empleados.find(empleados => empleados.key === dataviajes[k].empleado);

				let nombre_empleado = (empleado !== undefined) ? empleado.nombre : '';
				let socio_empleado = (empleado !== undefined) ? empleado.socio : '';


				if (dataviajes[k].fechaBajada !== undefined) {

					newViajes.push({
						key: k,
						empleado: nombre_empleado,
						total: '$' + dataviajes[k].total,
						fecha: (dataviajes[k].fechaBajada !== undefined)?new Date(dataviajes[k].fechaBajada) : "",
						lugar: dataviajes[k].lugar,
						socio: socio_empleado

					})

				}


			}
			this.setState({viajes: newViajes, viajestemp: newViajes, salvar:newViajes});



		}



	}
	errDataViajes = (err) => {

		console.log(err);

	}


	handleClickPrint() {

		this.updateStateReport();

	}


	handleKeyPress() {

		let newViaje = [];


		this.state.viajes = this.state.viajestemp;

		for (let i = 0; i < this.state.viajes.length; i++) {

			let empleado = false;
			let fecha = false;
			let total = false;
			let lugar = false;
			let socio = false;

			if (this.state.viajes[i].empleado !== undefined)
				empleado = (this.state.viajes[i].empleado.toLowerCase().search(this.busqueda.value.toLowerCase()) >= 0 ? true : false);

			if (this.state.viajes[i].fecha !== undefined)
				fecha = (this.state.viajes[i].fecha.toLowerCase().search(this.busqueda.value.toLowerCase()) >= 0 ? true : false);

			if (this.state.viajes[i].total !== undefined)
				total = (this.state.viajes[i].total.toLowerCase().search(this.busqueda.value.toLowerCase()) >= 0) ? true : false;

			if (this.state.viajes[i].lugar !== undefined)
				lugar = (this.state.viajes[i].lugar.toLowerCase().search(this.busqueda.value.toLowerCase()) >= 0) ? true : false;

			if (this.state.viajes[i].socio !== undefined)
				socio = (this.state.viajes[i].socio.toLowerCase().search(this.busqueda.value.toLowerCase()) >= 0) ? true : false;


			if (empleado || fecha || total || lugar || socio) {

				newViaje.push({
					key: this.state.viajes[i].key,
					empleado: this.state.viajes[i].empleado,
					fecha: this.state.viajes[i].fecha,
					total: this.state.viajes[i].total,
					lugar: this.state.viajes[i].lugar,
					socio: this.state.viajes[i].socio

				})
			}

		}
		this.state.viajes = newViaje;
		this.setState({
			viajes: newViaje
		})

	}

	handleInputDate1Changed() {

		this.setState({
			fecha_minima: this.fecha1.value,
			input_disabled: ''
		})

		if (this.fecha2.value !== "") {

			this.fecha2.value = "";


		}
		this.setState({viajes:this.state.salvar})

	}

	handleInputDate2Changed() {

		

		let inputDateInicio = this.fecha1.value;
		let inputDateFin = this.fecha2.value;

		let f1 = new Date(inputDateInicio);
		let f2 = new Date(inputDateFin);


		let newArray = [];



		for (let i = 0; i < this.state.viajes.length; i++) {


			if (this.state.viajes[i].fecha !== undefined && this.state.viajes[i].fecha !== "") {

				let fecha_registro = new Date(this.state.viajes[i].fecha);



				if (fecha_registro.getTime() >= f1.getTime() && fecha_registro.getTime() <= f2.getTime()) {


					newArray.push({

						key: this.state.viajes[i].key,
						empleado: this.state.viajes[i].empleado,
						fecha: this.state.viajes[i].fecha,
						pago: this.state.viajes[i].pago,
						total: this.state.viajes[i].total,
						socio: this.state.viajes[i].socio,
						lugar: (this.state.viajes[i].lugar !== undefined) ? this.state.viajes[i].lugar : ""

					})


				}


			}


		}
		this.setState({

			salvarFiltrado:newArray,
			viajes: newArray
		})

	}


	handleOnClickRegistrosGenerales() {

		this.fecha1.value = "";
		this.fecha2.value = "";
		this.setState({
			input_disabled: 'disabled',
			fecha_minima: '',
			viajes: this.state.viajestemp

		})


	}

	onKeyUpFilter = () =>{
		
		if(this.state.viajestemp===[]){
			this.setState({viajestemp:this.state.viajes});
		}
		let newSearch=[];
		let socio=this.socio.value;
		let conductor=this.conductor.value;
		let lugar = this.lugar.value;
		if(socio!==''|| conductor!=='' || lugar!=='')
		{
			for(let i=0;i<this.state.viajes.length;i++){
				let lu = (this.state.viajes[i].lugar !== undefined) ? this.state.viajes[i].lugar : ""
				let socio_filter=this.state.viajes[i].socio.toLowerCase().search(socio.toLowerCase())>=0?true:false;		
				let conductor_filter=this.state.viajes[i].empleado.toLowerCase().search(conductor.toLowerCase())>=0?true:false;	
				let lugar_filter=lu.toLowerCase().search(lugar.toLowerCase())>=0?true:false;			
					if(socio_filter && conductor_filter && lugar_filter){
						
						newSearch.push({
							
							key: this.state.viajes[i].key,
							empleado: this.state.viajes[i].empleado,
							fecha: this.state.viajes[i].fecha,
							pago: this.state.viajes[i].pago,
							total: this.state.viajes[i].total,
							socio: this.state.viajes[i].socio,
							lugar: (this.state.viajes[i].lugar !== undefined) ? this.state.viajes[i].lugar : ""
							
						})
						
						
						
					}
			}
			this.setState({
				
				viajes:newSearch
			})
		}
		else{
			if(this.fecha1.value==='')
			{
				this.setState({
					viajes:this.state.viajestemp
				})
			}
			else{
				this.setState({viajes:this.state.salvarFiltrado})
			}
		}
		
	}



	render() {

		return (

			<div className="reporte_conductores">

				<center><h3>Viajes por conductores</h3></center>



				<div className="row" style={styles}>

					<div className="col-md-2">
						<br />
						<Link to="template" className="btn btn-success" onClick={this.handleClickPrint}><span class="glyphicon glyphicon-print"> Imprimir</span></Link>
					</div>

					<div className="col-md-3">
						<div className="form-group">
							<label>Fecha Inicio</label>
							<input type="date" className="form-control" max={this.state.fecha_actual} onChange={this.handleInputDate1Changed}
								ref={input => { this.fecha1 = input; }}
							/>
						</div>
					</div>

					<div className="col-md-3">
						<div className="form-group">
							<label>Fecha Final</label>
							<input type="date" className="form-control" max={this.state.fecha_actual} min={this.state.fecha_minima} disabled={this.state.input_disabled}
								ref={input => { this.fecha2 = input; }} onChange={this.handleInputDate2Changed}
							/>
						</div>
					</div>
					

					
					<div className="col-md-2">
						<div className="form-group">
							<label htmlFor="socio">Socio</label>
							<input type="text" name="socio" placeholder="Socio" className="form-control"
								ref={input => { this.socio = input; }}
								onKeyUp={this.onKeyUpFilter}
							/>
						</div>
					</div>
					<div className="col-md-2">
						<div className="form-group">
							<label htmlFor="conductor">Conductor</label>
							<input type="text" name="conductor" placeholder="conductor" className="form-control"
								ref={input => { this.conductor = input; }}
								onKeyUp={this.onKeyUpFilter}
							/>
						</div>
					</div>
					<div className="col-md-2">
						<div className="form-group">
							<label htmlFor="lugar">Lugar</label>
							<input type="text" name="lugar" placeholder="lugar" className="form-control"
								ref={input => { this.lugar = input; }}
								onKeyUp={this.onKeyUpFilter}
							/>
						</div>
					</div>


				</div>

				<BootstrapTable data={this.state.viajes}
					ref='table'
					pagination={true}
					search={false}
					hover
				>
					<TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
					<TableHeaderColumn dataField='empleado' dataSort={true}  >Conductor</TableHeaderColumn>
					<TableHeaderColumn dataField='fecha' dataSort={true} dataAlign='center'>Fecha</TableHeaderColumn>
					<TableHeaderColumn dataField='total' dataSort={true} dataAlign='center' >Costo</TableHeaderColumn>
					<TableHeaderColumn dataField='lugar' dataSort={true} dataAlign='center' >Lugar</TableHeaderColumn>
					<TableHeaderColumn dataField='socio' dataSort={true} dataAlign='center' >Socio</TableHeaderColumn>

				</BootstrapTable>

			</div>

		)


	}


}

export default ViajesConductor;


// WEBPACK FOOTER //
// ./src/Components/Reportes/ViajesConductor.jsx